import { gql } from '@apollo/client';

import { Server } from '../../apollo/types';
import { useAppDependenciesContext } from '../../state';

type MomentumPilotPatientFeatureAccess = {
  key: string;
  enabled: boolean;
  disabledReasons: {
    disabledByType: string;
  }[];
};

type MomentumPilotAccessForPatientQuery = {
  momentumPilotFeatureForPatient: MomentumPilotPatientFeatureAccess;
};

type MomentumPilotAccessForPatientQueryVariables = {
  patientShortId: string;
  key: string;
  appVersion: string;
};

export const MOMENTUM_PILOT_ACCESS_QUERY = gql`
  query MomentumPilotFeatureForPatient($patientShortId: String!, $key: String!, $appVersion: String) {
    momentumPilotFeatureForPatient(patientShortId: $patientShortId, key: $key, appVersion: $appVersion) {
      key
      enabled
      disabledReasons {
        disabledByType
      }
    }
  }
`;

export function useMomentumPilotPatientAccessQuery(patientShortId: string, key: string, appVersion: string) {
  const { useQuery } = useAppDependenciesContext();

  const { data, loading, error } = useQuery<
    MomentumPilotAccessForPatientQuery,
    MomentumPilotAccessForPatientQueryVariables
  >(MOMENTUM_PILOT_ACCESS_QUERY, {
    variables: {
      patientShortId,
      key,
      appVersion,
    },
    skip: !patientShortId || !key || !appVersion,
    context: {
      server: Server.MONOLITH,
    },
  });

  return {
    pilotAccess: data?.momentumPilotFeatureForPatient,
    loading,
    error,
  };
}
